import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { ValidatorForm } from "react-material-ui-form-validator";
import AdminFetchServerData from "../../../provider/AdminFetchServerData";
import store from "../../../redux/store";
import AdminMenuWithBreadScrum from "../adminMenu/AdminMenuWithBreadScrum";
import PtsAlert from "../../givBee/ptsAlert/PtsAlert";
import CreateButton from "../../givBee/buttons/CreateButton";
import CancelIconButton from "../../givBee/buttons/CancelIconButton";
import { ApcreateuseCase_Url } from "../../../provider/ServiceUrl";

class UseCase extends Component {
  title = "Business Use Case";
  breadCrumb = [
    { pageid: "/billingPlans", uiname: "Business Type List" },
    { pageid: "", uiname: "Use Cases" },
  ];
  header = store.getState().adminHeader.adminHeader; // Ensure the header is set correctly

  constructor(props) {
    super(props);
    const { action } = props.state || {};

    let propBusinessDomain = null;
    let propBusinessType = null;
    let propBusinessUseCase = null;

    if (props.state) {
      propBusinessDomain = props.state?.businessDomain;
      propBusinessType = props.state?.businessType;
      propBusinessUseCase = props.state?.businessUseCase;
    }

    this.state = {
      action: action,
      useCaseName: "",
      businessDomain: propBusinessDomain,
      businessType: propBusinessType,
      businessUseCase: propBusinessUseCase,
    };
  }

  createCancel() {
    this.props.navigate("/useCaseList", {
      state: {
        action: "view",
        businessType: this.state.businessType,
        businessDomain: this.state.businessDomain,
      },
    });
  }

  async createBusinessUseCaseToBackend() {
    const postObject = {
      header: this.header,
      businessUseCase: {
        name: this.state.useCaseName,
        businessType: {
          id: this.state.businessType.id,
        },
      },
    };

    try {
      const response = await AdminFetchServerData.callPostService(
        ApcreateuseCase_Url,
        postObject
      );

      if (response.status === "SUCCESS") {
        PtsAlert.success(response.message);

        this.props.navigate(`/planList`, {
          state: {
            action: "view",
            businessType: this.state.businessType,
            businessDomain: this.state.businessDomain,
            businessUseCase: {
              id: response.data.businessUseCase.id,
              name: response.data.businessUseCase.name,
            },
          },
        });
      } else {
        PtsAlert.error("Failed to create use case. Please try again.");
      }
    } catch (error) {
      PtsAlert.error("An error occurred. Please try again later.");
    }
  }

  handleBusinessUseCaseNameChange(e) {
    this.setState({ useCaseName: e.target.value });
  }

  render() {
    if (this.state.action === "create") {
      return this.createBusinessUseCase();
    }
  }

  createBusinessUseCase() {
    return (
      <>
        <AdminMenuWithBreadScrum
          breadCrumb={this.breadCrumb}
          businessDomain={this.state.businessDomain}
          history={this.props.history}
          name={this.title}
        />
        <div className="row">
          <ValidatorForm
            className="text-start"
            ref="form"
            onSubmit={this.createBusinessUseCaseToBackend.bind(this)}
          >
            <div className="row" style={{ marginTop: "1em" }}>
              <div className="col-md-12">
                <div className="card" id="organizationFormCard">
                  <div className="card-body">
                    <div className="col-md-6">
                      <div className="row">
                        <label
                          className="col-sm-3 col-form-label"
                          htmlFor="collapsible-firstname"
                        >
                          Domain Name:
                        </label>
                        <div className="col-sm-9 align-self-center" id="assetFormLabel">
                          <span>{this.state.businessDomain?.name}</span>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <label
                          className="col-sm-3 col-form-label"
                          htmlFor="collapsible-firstname"
                        >
                          Business Type:
                        </label>
                        <div className="col-sm-9 align-self-center" id="assetFormLabel">
                          <span>{this.state.businessType.name}</span>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <label
                          className="col-sm-3 col-form-label"
                          htmlFor="collapsible-firstname"
                        >
                          Use Case Name:
                        </label>
                        <div className="col-sm-9 align-self-center" id="assetFormLabel">
                          <textarea
                            rows="4"
                            required
                            title=""
                            autoFocus={true}
                            autoComplete="off"
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="form-control"
                            value={this.state.useCaseName}
                            onChange={this.handleBusinessUseCaseNameChange.bind(
                              this
                            )}
                            validators={["required"]}
                            errormessages={["This field is required"]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-flex align-items-center justify-content-between">
              <div className="col-sm-12 mt-3 text-center">
                <CreateButton btnName="Create" type="submit" />
                &nbsp;&nbsp;
                <CancelIconButton onClick={(e) => this.createCancel()} />
              </div>
            </div>
          </ValidatorForm >
        </div >
      </>
    );
  }
}

export default withRouter(UseCase);
